import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-messenger-drawer',
    templateUrl: './messenger-drawer.component.html',
    standalone: false
})
export class MessengerDrawerComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
